import { render } from "./FooterVie.vue?vue&type=template&id=fc55e63c"
import script from "./FooterVie.vue?vue&type=script&lang=js"
export * from "./FooterVie.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__